/* Slide cart + native Buy Now.
   - Add to cart  -> AJAX, opens the slide cart (no page reload)
   - Buy it now   -> AJAX, straight to /checkout (standard Shopify behaviour)
   - Releasit COD -> hidden via how-cart.css; disable the app embed to stop it loading */
(function () {
  'use strict';
  if (window.HOWCart) return;

  var root, panel, scrim, cfg = {}, cart = null, busy = false;
  var DISCOUNT_KEY = 'how_cart_discount';

  var fmt = function (p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); };
  function buildFmt(sample) {
    if (!sample) return;
    var m = String(sample).trim().match(/^([^\d]*)([\d.,]+)([^\d]*)$/);
    if (!m) return;
    var pre = m[1], suf = m[3], dec = /[.,]\d{2}$/.test(m[2]) ? 2 : 0;
    fmt = function (p) {
      return pre + (p / 100).toLocaleString('en-IN',
        { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf;
    };
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function thumb(url, w) {
    if (!url) return '';
    return url.replace(/(\.(jpg|jpeg|png|webp|gif))(\?|$)/i, '_' + w + 'x$1$3');
  }

  function open() {
    if (!panel) return;
    scrim.classList.add('is-on'); panel.classList.add('is-on');
    document.body.style.overflow = 'hidden';
    panel.setAttribute('aria-hidden', 'false');
    var x = panel.querySelector('.howc-x'); if (x) x.focus();
  }
  function close() {
    if (!panel) return;
    scrim.classList.remove('is-on'); panel.classList.remove('is-on');
    document.body.style.overflow = '';
    panel.setAttribute('aria-hidden', 'true');
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; render(); syncBubble(c); return c; });
  }
  function syncBubble(c) {
    document.querySelectorAll('.cart-bubble__text, [id^=cart-bubble-text]').forEach(function (e) {
      if (/^\d+$/.test((e.textContent || '').trim())) e.textContent = c.item_count;
    });
  }
  function setBusy(v) { busy = v; if (panel) panel.classList.toggle('is-busy', v); }
  function change(key, qty) {
    if (busy) return;
    setBusy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (c) { cart = c; render(); syncBubble(c); })
      .catch(function () { return getCart(); })
      .finally(function () { setBusy(false); });
  }

  function cutdown(el) {
    if (!el) return;
    var hour = parseInt(cfg.cutoffHour, 10);
    if (isNaN(hour)) return;
    function tick() {
      var now = new Date(), end = new Date(now);
      end.setHours(hour, 0, 0, 0);
      if (end <= now) end.setDate(end.getDate() + 1);
      var s = Math.floor((end - now) / 1000);
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), ss = s % 60;
      el.textContent = h + 'h ' + String(m).padStart(2, '0') + 'm ' + String(ss).padStart(2, '0') + 's';
    }
    tick(); if (el.__t) clearInterval(el.__t); el.__t = setInterval(tick, 1000);
  }

  function render() {
    if (!panel || !cart) return;
    var countEl = panel.querySelector('[data-howc-count]');
    if (countEl) countEl.textContent = cart.item_count;
    var body = panel.querySelector('[data-howc-body]');
    var foot = panel.querySelector('[data-howc-foot]');
    var chrome = panel.querySelectorAll('[data-howc-full]');

    if (!cart.items.length) {
      chrome.forEach(function (e) { e.style.display = 'none'; });
      if (foot) foot.style.display = 'none';
      body.innerHTML = '<div class="howc-empty">' +
        '<div class="howc-empty__t">' + esc(cfg.emptyTitle) + '</div>' +
        '<div class="howc-empty__s">' + esc(cfg.emptyText) + '</div>' +
        '<a href="' + esc(cfg.emptyLink || '/collections/all') + '">' + esc(cfg.emptyCta) + '</a></div>';
      return;
    }
    chrome.forEach(function (e) { e.style.display = ''; });
    if (foot) foot.style.display = '';

    var html = '<ul class="howc-items">';
    cart.items.forEach(function (it) {
      var isFree = it.final_line_price === 0;
      var hasWas = it.original_line_price > it.final_line_price;
      html += '<li class="howc-item" data-key="' + esc(it.key) + '">' +
        '<span class="howc-item__img">' + (it.image ? '<img src="' + esc(thumb(it.image, 160)) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span><span class="howc-item__n">' + esc(it.product_title) + '</span>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<span class="howc-item__v">' + esc(it.variant_title) + '</span>' : '') +
        (isFree ? '<span class="howc-item__tag">' + esc(cfg.giftBadge) + '</span>' : '') +
        '<span class="howc-qty">' +
        '<button type="button" data-howc-dec aria-label="Decrease quantity">&minus;</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-howc-inc aria-label="Increase quantity">+</button>' +
        '</span></span>' +
        '<span class="howc-item__r">' +
        '<span class="howc-item__p">' + (isFree ? esc(cfg.freeWord) : fmt(it.final_line_price)) + '</span>' +
        (hasWas ? '<s class="howc-item__was">' + fmt(it.original_line_price) + '</s>' : '') +
        '<button type="button" class="howc-item__rm" data-howc-rm>Remove</button>' +
        '</span></li>';
    });
    body.innerHTML = html + '</ul>';

    var ship = panel.querySelector('[data-howc-ship]');
    if (ship) {
      var thr = parseInt(cfg.shipThreshold, 10) || 0;
      if (thr > 0) {
        ship.style.display = '';
        var left = thr - cart.total_price;
        var pct = Math.min(100, Math.round((cart.total_price / thr) * 100));
        var t = ship.querySelector('[data-howc-ship-text] span');
        var f = ship.querySelector('[data-howc-ship-fill]');
        if (left <= 0) { ship.classList.add('is-done'); if (t) t.innerHTML = '<b>' + esc(cfg.shipDone) + '</b>'; }
        else { ship.classList.remove('is-done'); if (t) t.innerHTML = esc(cfg.shipPrefix) + ' <b>' + fmt(left) + '</b> ' + esc(cfg.shipSuffix); }
        if (f) f.style.width = pct + '%';
      } else { ship.style.display = 'none'; }
    }

    var savings = cart.original_total_price - cart.total_price;
    var saveRow = panel.querySelector('[data-howc-saverow]');
    if (saveRow) {
      if (savings > 0) { saveRow.style.display = ''; saveRow.querySelector('[data-howc-save]').textContent = '−' + fmt(savings); }
      else saveRow.style.display = 'none';
    }
    var sub = panel.querySelector('[data-howc-subtotal]');
    if (sub) sub.textContent = fmt(cart.total_price);
    var cop = panel.querySelector('[data-howc-co-price]');
    if (cop) cop.textContent = fmt(cart.total_price);
    cutdown(panel.querySelector('[data-howc-cd]'));
  }

  function initDiscount() {
    var wrap = panel.querySelector('[data-howc-disc]');
    if (!wrap) return;
    var input = wrap.querySelector('input'), btn = wrap.querySelector('button');
    var saved = '';
    try { saved = sessionStorage.getItem(DISCOUNT_KEY) || ''; } catch (e) {}
    if (saved) { input.value = saved; wrap.classList.add('is-applied'); }
    btn.addEventListener('click', function () {
      var code = (input.value || '').trim(); if (!code) return;
      try { sessionStorage.setItem(DISCOUNT_KEY, code); } catch (e) {}
      wrap.classList.add('is-applied');
    });
    input.addEventListener('input', function () {
      wrap.classList.remove('is-applied');
      try { sessionStorage.removeItem(DISCOUNT_KEY); } catch (e) {}
    });
  }
  function checkoutUrl() {
    var code = '';
    try { code = sessionStorage.getItem(DISCOUNT_KEY) || ''; } catch (e) {}
    return code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
  }

  /* ---------- add to cart -> slide cart ---------- */
  function initForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var btn = form.querySelector('[type=submit]');
      if (btn) { btn.disabled = true; btn.style.opacity = '.7'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { return getCart(); })
        .then(open)
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; btn.style.opacity = ''; } });
    }, true);
  }

  /* ---------- native Buy it now ---------- */
  function initBuyNow() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.__buyNow) return; form.__buyNow = 1;
      var atc = form.querySelector('[type=submit]');
      if (!atc || form.querySelector('.how-buynow')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'how-buynow';
      b.textContent = cfg.buyNowLabel || 'BUY IT NOW';
      b.addEventListener('click', function () {
        b.disabled = true; b.classList.add('is-loading');
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
          .then(function () { window.location.href = checkoutUrl(); })
          .catch(function () { b.disabled = false; b.classList.remove('is-loading'); });
      });
      atc.insertAdjacentElement('afterend', b);
    });
  }

  /* ---------- cart icon opens the slide cart ---------- */
  function initTriggers() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var t = e.target.closest('[data-howc-open], [data-testid="cart-drawer-trigger"], a[href$="/cart"], a[href*="/cart?"]');
      if (!t || t.closest('.howc-panel')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      getCart().then(open);
    }, true);
  }

  function initPanel() {
    root = document.querySelector('[data-howc-root]');
    if (!root) return;
    panel = root.querySelector('.howc-panel');
    scrim = root.querySelector('.howc-scrim');
    try { cfg = JSON.parse(root.getAttribute('data-howc-config') || '{}'); } catch (e) { cfg = {}; }
    buildFmt(root.getAttribute('data-money-sample'));
    scrim.addEventListener('click', close);
    panel.querySelector('.howc-x').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    panel.addEventListener('click', function (e) {
      var li = e.target.closest('.howc-item'); if (!li) return;
      var key = li.getAttribute('data-key');
      var qty = parseInt(li.querySelector('.howc-qty span').textContent, 10) || 1;
      if (e.target.closest('[data-howc-inc]')) change(key, qty + 1);
      else if (e.target.closest('[data-howc-dec]')) change(key, Math.max(0, qty - 1));
      else if (e.target.closest('[data-howc-rm]')) change(key, 0);
    });
    var co = panel.querySelector('[data-howc-checkout]');
    if (co) co.addEventListener('click', function () { window.location.href = checkoutUrl(); });
    initDiscount();
    getCart();
  }

  function boot() { initPanel(); initForms(); initBuyNow(); initTriggers(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { initBuyNow(); });

  window.HOWCart = { open: function () { return getCart().then(open); }, close: close, refresh: getCart };
})();
